import { DocumentNode, gql } from '@apollo/client'

export const UPDATE_STAFF_RIGHTS: DocumentNode = gql`
    mutation (
        $staff_id: Int!
        $daycare_id: Int!
        $rw_params_daycare: RightsRW
        $rw_staffs: RightsRW
        $rw_staff_work: RightsRW
        $rw_families: RightsRW
        $rw_child: RightsRW
        $rw_occasional_slot: RightsRW
        $rw_request_slot: RightsRW
        $rw_regular_slot: RightsRW
        $rw_news: RightsRW
        $rw_event_days: RightsRW
        $rw_closing_days: RightsRW
        $w_add_posts: Boolean
        $rw_suggestions: RightsRW
        $rw_task_note: RightsRW
        $rw_meal: RightsRW
    ) {
        updateStaffRights(
            staff_id: $staff_id
            daycare_id: $daycare_id
            rights: {
                rw_params_daycare: $rw_params_daycare
                rw_staffs: $rw_staffs
                rw_staff_work: $rw_staff_work
                rw_families: $rw_families
                rw_child: $rw_child
                rw_occasional_slot: $rw_occasional_slot
                rw_request_slot: $rw_request_slot
                rw_regular_slot: $rw_regular_slot
                rw_news: $rw_news
                rw_event_days: $rw_event_days
                rw_closing_days: $rw_closing_days
                w_add_posts: $w_add_posts
                rw_suggestions: $rw_suggestions
                rw_task_note: $rw_task_note
                rw_meal: $rw_meal
            }
        )
    }
`

export const STAFF_DELINKS: DocumentNode = gql`
    mutation ($email: Email!, $daycare_id: Int!) {
        delinkStaff(email: $email, daycare_id: $daycare_id)
    }
`

export const STAFF_LINKS: DocumentNode = gql`
    mutation linkStaffs($email: Email!, $daycare_id: Int!, $from_suggest: Boolean) {
        linkStaff(email: $email, daycare_id: $daycare_id, from_suggest: $from_suggest)
    }
`

export const CHANGE_LINK_NOTIFS: DocumentNode = gql`
    mutation ChangeLinkNotifs(
        $daycare_id: Int!
        $notifReport: Boolean
        $notifNewParent: Boolean
        $notifPushNewParent: Boolean
        $notifUpdateParent: Boolean
        $notifPushUpdateParent: Boolean
        $notifNewStaff: Boolean
        $notifPushNewStaff: Boolean
        $notifConfirmation: Boolean
        $notifPushConfirmation: Boolean
        $notifCancellation: Boolean
        $notifPushCancellation: Boolean
        $notifRequestSlot: Boolean
        $notifPushRequestSlot: Boolean
        $notifEventDays: Boolean
        $notifPushEventDays: Boolean
        $notifRegularSlot: Boolean
        $notifPushRegularSlot: Boolean
        $notifTaskNote: Boolean
        $notifPushTaskNote: Boolean
    ) {
        changeLinkNotifs(
            daycare_id: $daycare_id
            notifs: {
                notifReport: $notifReport
                notifNewParent: $notifNewParent
                notifPushNewParent: $notifPushNewParent
                notifUpdateParent: $notifUpdateParent
                notifPushUpdateParent: $notifPushUpdateParent
                notifNewStaff: $notifNewStaff
                notifPushNewStaff: $notifPushNewStaff
                notifConfirmation: $notifConfirmation
                notifPushConfirmation: $notifPushConfirmation
                notifCancellation: $notifCancellation
                notifPushCancellation: $notifPushCancellation
                notifRequestSlot: $notifRequestSlot
                notifPushRequestSlot: $notifPushRequestSlot
                notifEventDays: $notifEventDays
                notifPushEventDays: $notifPushEventDays
                notifRegularSlot: $notifRegularSlot
                notifPushRegularSlot: $notifPushRegularSlot
                notifTaskNote: $notifTaskNote
                notifPushTaskNote: $notifPushTaskNote
            }
        )
    }
`

export const CREATE_MOCK_STAFF: DocumentNode = gql`
    mutation createMockStaff($daycareId: Int!, $firstname: String!, $lastname: String!, $degree: Diplomas) {
        createMockStaff(daycareId: $daycareId, firstname: $firstname, lastname: $lastname, degree: $degree)
    }
`
